import { RouteProp } from "@react-navigation/core"
import React, { FC } from "react"

import MfaSmsValidationForm from "../../components/MfaSmsValidationForm"
import { RootParamList } from "../../features/Navigation/types"

type MfaLoginScreenRouteProp = RouteProp<RootParamList, "MfaLogin">

interface IProps {
  route: MfaLoginScreenRouteProp
}
const MfaLoginScreen: FC<IProps> = ({ route }) => {
  const { verifId } = route.params

  return <MfaSmsValidationForm verifId={verifId} />
}
export default MfaLoginScreen
